<template>
  <div class="carousel-section">
    <title-session-component :title="title" tag="h1" />
    <vue-slick-carousel  v-if="!loading" ref="slickCarousel" :dots="false" :infinite="false" :speed="500" :slides-to-show="slidesToShow"
      :slides-to-scroll="1" :center-mode="false" :center-padding="'0px'" class="carousel-container">
      <template #prevArrow>
        <div class="custom-arrow left-arrow" @click="prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </div>
      </template>

      <template #nextArrow>
        <div class="custom-arrow right-arrow" @click="next">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 24 24">
            <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
          </svg>
        </div>
      </template>


      <div  v-for="(item, index) in items" :key="index" class="carousel-item">
        <ProjectCard v-if="type == 'projects'" :cardData="item" :has-background-image="hasBackgroundImage" />
        <TitleCard v-if="type == 'titles'" :cardData="item" />
        <CommonCard v-if="type == 'last-updated'" :cardData="item" />
        <ProjectCard v-if="type == 'zinnes'" :cardData="item" :has-background-image="hasBackgroundImage" :is-zinnes-original="true" />
      </div>
    </vue-slick-carousel>
    <div v-else class="skeleton-carousel">
      <div v-for="n in slidesToShow" :key="n" class="skeleton-card"></div>
    </div>
  </div>
</template>

<script>
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueSlickCarousel from "vue-slick-carousel";
import TitleSessionComponent from '@/components/TitleSessionComponent.vue';
import ProjectCard from './cards/ProjectCard.vue';
import TitleCard from './cards/TitleCard.vue';
import CommonCard from "./CommonCard.vue";

export default {
  name: "CarouselSection",
  components: {
    VueSlickCarousel,
    ProjectCard,
    TitleSessionComponent,
    TitleCard,
    CommonCard
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    type: {
      type: String,
      default: 'projects',
    },
    loading: { type: Boolean, default: false },
    hasBackgroundImage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      showArrows: window.innerWidth > 700,
    };
  },
  computed: {
    slidesToShow() {
      if (this.screenWidth <= 768) return 2.5; // Mobile: 2.5 cards (mostra que tem mais)
      if (this.screenWidth <= 1024) return 3; // Tablet
      if (this.screenWidth <= 1440) return 4; // Desktop médio
      if (this.screenWidth <= 2550) return 5; // Desktop grande
      return 6; // Ultrawide
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("resize", this.updateShowArrows);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.updateShowArrows);
  },

  methods: {

    handleResize() {
      this.screenWidth = window.innerWidth;
      this.showArrows = this.screenWidth > 700; // Atualiza dinamicamente
    },
    updateShowArrows() {
      this.showArrows = window.innerWidth > 430;
    },
    prev() {
      this.$refs.slickCarousel.slickPrev();
    },
    next() {
      this.$refs.slickCarousel.slickNext();
    },
  },
};
</script>

<style scoped>
.carousel-section {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

@media (max-width: 768px) {
  .carousel-section {
    margin-bottom: 8px;
    gap: 0;
  }
}

.skeleton-carousel {
  display: flex;
  gap: 14px;
  padding: 10px;
}

.skeleton-card {
  width: 100%;
  height: 450px;
  background: linear-gradient(90deg, #2b2b2b 25%, #3b3b3b 50%, #2b2b2b 75%);
  background-size: 400% 400%;
  animation: pulse 1.2s ease-in-out infinite;
  border-radius: 8px;
  flex: 1;
}

@keyframes pulse {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}


.carousel-container ::v-deep .slick-prev::before,
.carousel-container ::v-deep .slick-next::before {
  display: none !important;
  content: none !important;
}

.custom-arrow {
  font-size: 40px !important;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50px;
  background-color: rgb(0, 0, 0);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.custom-arrow:hover {
  background-color: rgb(0, 0, 0);
}

.left-arrow {
  left: 0;
}

.right-arrow {
  right: 0;
}

@media (max-width: 768px) {
  .custom-arrow {
    display: none;
  }
}

.carousel-item {
  padding: 15px;
}

@media (max-width: 768px) {
  .carousel-item {
    padding: 8px;
  }
}

.custom-arrow {
  font-size: 40px;
  background-color: rgb(0, 0, 0);
  border-radius: 50%;
  color: white;
  opacity: 0.7;
  transition: opacity 0.3s ease;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.custom-arrow:hover {
  opacity: 1;
}

.left-arrow {
  left: 15px;
}

.right-arrow {
  right: 15px;
}

@media (max-width: 768px) {
  .custom-arrow {
    font-size: 30px;
  }
}

.carousel-container {
  border-radius: 8px;
  gap: 20px;
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Target slick slides directly with deep selector */
.carousel-container ::v-deep .slick-slide {
  padding: 0 10px;
}

.carousel-container ::v-deep .slick-list {
  margin: 0 -10px !important;
  padding: 0 !important;
}

@media (max-width: 768px) {
  .carousel-container ::v-deep .slick-slide {
    padding: 0 5px;
  }

  .carousel-container ::v-deep .slick-list {
    margin: 0 -5px !important;
    padding: 0 !important;
  }
}

.carousel-item {
  padding: 0;
  width: 100%;
  display: inline-block;
}

.carousel-item > div {
  width: 100%;
}


.custom-arrow {
  font-size: 30px;
  /* Tamanho do ícone padrão */
  color: white;
  /* Cor do ícone */
  cursor: pointer;
  /* Indica que é clicável */
  width: 30px;
  /* Largura padrão */
  height: 30px;
  /* Altura padrão */
  display: inline-flex;
  /* Para centrar o conteúdo */
  align-items: center;
  /* Centraliza verticalmente */
  justify-content: center;
  /* Centraliza horizontalmente */
}

/* Estilos para dispositivos móveis */
@media (max-width: 768px) {
  .custom-arrow {
    width: 20px;
    /* Menor largura para ícones em dispositivos móveis */
    height: 20px;
    /* Menor altura para ícones em dispositivos móveis */
    font-size: 20px;
    /* Reduz o tamanho do ícone */
  }

  .custom-arrow {
    display: none;
  }

  .carousel-item {
    max-width: 150px !important;
    /* Ajuste o tamanho máximo dos itens para dispositivos móveis */
  }

  .carousel-section h2 {
    font-size: 1.25rem;
    /* Ajusta o tamanho do título */
    text-align: center;
    /* Centraliza o texto do título */
  }



}
</style>
